<template>  
  <div>
    <h3>EBITDA según año fiscal</h3>
		<v-layout>
			<v-flex md12 class="px-4">
        <v-select
          :placeholder="selectedYear ? undefined: 'Seleccionar el año'"
          v-model="selectedYear"
          :items="years"/>
			</v-flex>
		</v-layout>
    <br>
		<v-layout v-if="selectedItem">
			<v-flex md6>
        <EbitByYear :year.sync="selectedYear"/>
			</v-flex>
      <v-flex md6 class="px-4">
        <br>
        <br>
        <br>
        <Bar :id="'assacxcx'" :datasets.sync="dataBar.datasets" :labels.sync="dataBar.labels" :legendDisplay="false" :beginAtZero="true"/>
        <!-- <LineChart :id="'ebit'"
          :datasets.sync="dataBar.datasets"
          :labels.sync="dataBar.labels"/>  -->
      </v-flex>
		</v-layout>
  </div>
</template>

<script>


import EbitByYear from '@/components/admin/EbitByYear.vue';
import LineChart from '@/components/graphs/Line.vue';
import Bar from '@/components/graphs/Bar.vue';
const color = ['rgb(255, 99, 132)',
  'rgb(54, 162, 235)',
  'rgb(255, 206, 86)',
  'rgb(75, 192, 192)',
  'rgb(153, 102, 255)',
  'rgb(255, 159, 64)'];
export default {
  data() {
    return {
      selectedItem: {},
      selectedYear:null,
    };
  },
  computed: {
    years() { return this.$store.getters.fiscal_years.map(m => m.year).sort((a,b) => b - a) },
    listImpactedAreas() { return this.$store.getters.listImpactedAreas },
    ebits() { return this.$store.getters.ebits },
    headers() {
      return [
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
				{ text: 'Año', sortable: true, value: 'fiscal_year' },
				{ text: 'Valor', sortable: true, value: 'value' },
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
      ];
    },
    dataBar() {
      const dataBar = {labels: [], datasets: []};
      if (!this.selectedYear) return dataBar;
      const ebitsY = this.ebits.filter(f => f.fiscal_year === this.selectedYear);
      const data = [];
      ebitsY.forEach(e => {
        const impA = this.listImpactedAreas.find(f => f.id === e.impacted_area) || {};
        const label = impA.full_name || '';
        dataBar.labels.push(label);
        data.push(e.value)
      })

          dataBar.datasets.push({
          label:'x',
          fill: false,
          data,
          backgroundColor: color,
          borderColor: color,
        })    

      return dataBar;
    },

  },
  components: { LineChart, EbitByYear, Bar },
};
</script>
